module.exports = __webpack_public_path__ + "static/media/phone-call.2d743990.svg";